/*
人员列表
*/
import {
  httpGet,
  httpImgPost,
  httpPost,
  httpFilePost
} from './http.js'
// 下载列表
const downloadList = (data) => {
  return httpPost({
    url: 'https://www.foxlean.com/renren-fast/app/appversion/queryVersionList',
    data
  })
}
const userList = (data) => {
  return httpPost({
    url: 'https://www.foxlean.com/renren-fast/appmange/usermange/queryInsterRecord',
    data
  })
}

export {
  downloadList,
  userList
}



// WEBPACK FOOTER //
// ./src/api.js